let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6NBej")).then(() => parcelRequire('k0bnv'));